import { Body, Footer, Header } from './components'

import { Box } from '@qonsoll/react-design'
import PropTypes from 'prop-types'

const WebTippsPagePreview = (props) => {
  const {
    publicWizardConfiguration,
    pageConfiguration,
    initialValues,
    countTipps,
    customBodyContent,
    children,
    customTitle,
    isWizard
  } = props
  const { newspaperId } = initialValues
  return (
    <Box display="flex" flex="1" flexDirection="column" position="relative">
      <Header
        publicWizardConfiguration={publicWizardConfiguration}
        pageConfiguration={pageConfiguration}
        initialValues={initialValues}
        isWizard={isWizard}
      />
      <Body
        customBodyContent={customBodyContent}
        pageConfiguration={pageConfiguration}
        newspaperId={newspaperId}
        countTipps={countTipps}
        customTitle={customTitle}
      />
      <Footer pageConfiguration={pageConfiguration} />
      {children}
    </Box>
  )
}
WebTippsPagePreview.propTypes = {
  initialValues: PropTypes.object,
  publicWizardConfiguration: PropTypes.object,
  pageConfiguration: PropTypes.object,
  countTipps: PropTypes.number,
  children: PropTypes.node,
  customBodyContent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  customTitle: PropTypes.string,
  isWizard: PropTypes.bool
}
export default WebTippsPagePreview
